import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FloatingPanelService {
  private flag$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setVisibility(value: boolean): void {
    this.flag$.next(value);
  }

  getVisibility(): BehaviorSubject<boolean> {
    return this.flag$;
  }
}
